module.exports = __webpack_public_path__ + "media/images/favicon-32x32-1b2cdf035381e715e663fcfbb456fe2f.png";